import moment, { Moment } from 'moment'

type BuildingData = {
  id: number
  name: string
  standardMeterReadingDay: number
  postalCode: string
  address: string
  isDormitory: boolean
}

type RoomData = {
  id: number
  name: string
}

export type TenantData = {
  id: number
  moveInOn: string
  moveOutOn: string | null
  payerFirstName: string | null
  payerLastName: string | null
  payerFirstNameKana: string | null
  payerLastNameKana: string | null
  emergencyContactFirstName: string | null
  emergencyContactLastName: string | null
  emergencyContactFirstNameKana: string | null
  emergencyContactLastNameKana: string | null
  emergencyContactRelationship: string | null
  consumptionAlertThreshold: number

  room: RoomData & {
    building: BuildingData
  }
}

export default class Tenant {
  declare id: number
  declare moveInOn: Moment
  declare moveOutOn: Moment | null
  declare payerFirstName: string | null
  declare payerLastName: string | null
  declare payerFirstNameKana: string | null
  declare payerLastNameKana: string | null
  declare emergencyContactFirstName: string | null
  declare emergencyContactLastName: string | null
  declare emergencyContactFirstNameKana: string | null
  declare emergencyContactLastNameKana: string | null
  declare emergencyContactRelationship: string | null
  declare consumptionAlertThreshold: number

  declare room: RoomData & {
    building: BuildingData
  }

  // Computed properties ------------------------------------------------------

  get payerName() {
    if (!this.payerFirstName) return this.payerLastName
    return `${this.payerLastName} ${this.payerFirstName}`
  }

  get payerKana() {
    if (!this.payerFirstNameKana) return this.payerLastNameKana
    return `${this.payerLastNameKana} ${this.payerFirstNameKana}`
  }

  get hasPayerInfo() {
    return !!this.payerName && !!this.payerKana
  }

  // Constructor --------------------------------------------------------------

  constructor(params: TenantData) {
    Object.assign(this, params)
    this.moveInOn = moment(params.moveInOn)
    this.moveOutOn = params.moveOutOn ? moment(params.moveOutOn) : null
  }
}
